export default __webpack_public_path__ + "static/media/easLogo.0860d72b.png";